export default {
  knowledgeLib_move:'轉移',
  knowledgeLib_copy:'復製',
  knowledgeLib_del:'刪除',
  knowledgeLib_download:'下載',
  knowledgeLib_upload:'上傳',
  knowledgeLib_enter_keywords:'請輸入關鍵字',
  knowledgeLib_enter_lib_name:'請輸入文庫名稱查詢',
  knowledgeLib_also_learning:'他們也在學習',
  knowledgeLib_file_uploading:'文件上傳中，請稍後重試',
  knowledgeLib_select_lib:'請選擇文庫！',
  knowledgeLib_upload_file:'請上傳文件！',
  knowledgeLib_select_lib_folder:'請選擇文庫或者文件夾！',
  knowledgeLib_select_path:'請選擇路徑：',
  knowledgeLib_support_extensions:'支持擴展名：.doc .docx .pdf .xlsx .xls .ppt .pptx .png .jpeg .jpg .bmp .msg .mht格式',
  knowledgeLib_just_now:'剛剛',
  knowledgeLib_minutes_ago:'{dm}分鐘之前',
  knowledgeLib_hour_ago:'{dm}小時之前',
  knowledgeLib_ten_thousand:'{n}萬',
  knowledgeLib_browse_num:'共{browseNum}個人看過',
  knowledgeLib_no_intro:'無簡介',
  knowledgeLib_library:'所屬文庫',
  knowledgeLib_create_user:'創建用戶',
  knowledgeLib_update_time:'更新時間',
  knowledgeLib_folder:'文件夾',
  knowledgeLib_fail_upload:'上傳失敗，請刪除後重新上傳',
  knowledgeLib_uploading:'上傳中',
  knowledgeLib_select_folder:"請選擇文件或文件夾!",
  knowledgeLib_success_tip:'成功',
  knowledgeLib_del_success:'刪除成功',
  knowledgeLib_enter_files_name:'輸入文件名',
  knowledgeLib_back_previous:"返回上一級",
  knowledgeLib_confirm_del:'是否要刪除這些文件',
  knowledgeLib_select_library:"請選擇文庫",
  knowledgeLib_choice_library:"請選擇文庫：",
  knowledgeLib_total_library:"全部文庫",
  knowledgeLib_total_number:'共{totalFileNum}個',
  knowledgeLib_no_access:'無訪問權限或暫無數據',
  knowledgeLib_enter_library_name:'輸入文庫名',
  knowledgeLib_no_library:"暫無文庫",
  knowledgeLib_classify:'分類',
  knowledgeLib_select_classify:'按分類查看',
  knowledgeLib_hot_files:'熱門文件',
  knowledgeLib_empty_files:"暫無文件",
  knowledgeLib_upload_user:"上傳用戶",
  knowledgeLib_files_num:'{totalFileNum}個文件',
  knowledgeLib_last_upload:"最新上傳",
  knowledgeLib_upload_time:'上傳時間',
  knowledgeLib_total_files:'全部文件',
  knowledgeLib_select:"請選擇文庫或者文件夾!",
  knowledgeLib_selected_all:"已使用/全部：",
}
